<template>
  <div class="order">
    <div class="order-top">
      <div class="order-top__name">入仓单</div>
      <div class="order-top__fun">
        <div class="order-top-item order-top-item--date">
          <div class="order-top-item__name">入仓日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="order-top-item">
          <div class="order-top-item__name">货件分类:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="order-top-item">
          <div class="order-top-item__name">发往国家:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="order-top-item">
          <div class="order-top-item__name">入仓单分类:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="order-top-item order-top-item--input">
          <el-input size="mini" placeholder="请输入货件追踪编号,FBA编号等"></el-input>
        </div>
        <div class="order-top__btn">搜索</div>
      </div>
    </div>
    <div class="order-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { WarehouseAllocationNewModule, OrderSearchData } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'warehouseReceipt',
  components: {
    Table
  },
  data(){
    return {
      searchData: OrderSearchData,
      TableHead: WarehouseAllocationNewModule.NEWINORDERTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.order{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 250px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
